module.exports = __webpack_public_path__ + "static/media/log.36622187.svg";